export default __webpack_public_path__ + "static/media/Lobby1-min.7c200ee4.jpg";